/**
 * @generated SignedSource<<8fb6cb24c02b13088ba048aebe79be24>>
 * @relayHash b9701fa18d6abf654ce34fd024939118
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/543.0.0-2026-01-22T17:55:48.216Z/SbRespLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type SbRespLayoutRefetchQuery$variables = {
  contentModuleId?: string | null;
  disableForceFacet?: boolean | null;
  disableNonParameterizedUrlRedirects?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchSb: boolean;
  fetchTileVideo?: boolean | null;
  fetchUser: boolean;
  first: number;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  guestId?: string | null;
  hasPersonalizedFilter: boolean;
  includeSponsoredItems?: boolean | null;
  interiorPhotosCount?: number | null;
  isClient: boolean;
  isTrade: boolean;
  localeOrigin?: string | null;
  marketTrendsUrl?: string | null;
  numOfItemsToInflate?: number | null;
  originalUrl?: string | null;
  page: number;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationId?: string | null;
  previewId?: string | null;
  priceBookName?: string | null;
  regions?: string | null;
  regionsList?: ReadonlyArray<string | null> | null;
  rerankGuestId?: string | null;
  rerankUserId?: string | null;
  showSeller: boolean;
  skipUser?: boolean | null;
  uriRef?: string | null;
  userCountryCode?: string | null;
  userId?: string | null;
  userZipCode?: string | null;
};
export type SbRespLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly itemSearch?: {
      readonly displayUriRef: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_itemSearch" | "SbSharedHead_itemSearch" | "SbSharedRefetchContainer_itemSearch" | "useSbSharedPageTracking_itemSearch">;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_regionalInfo">;
    } | null> | null;
    readonly shippingFilters?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_shippingFilters" | "SbSharedRefetchContainer_shippingFilters">;
    } | null> | null;
    readonly user?: {
      readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_user" | "useSbSharedPageTracking_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_viewer" | "useSbSharedPageTracking_viewer">;
  };
};
export type SbRespLayoutRefetchQuery = {
  response: SbRespLayoutRefetchQuery$data;
  variables: SbRespLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "contentModuleId"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "disableForceFacet"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "disableNonParameterizedUrlRedirects"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchSb"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchTileVideo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v9 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v10 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasPersonalizedFilter"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSponsoredItems"
},
v13 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "interiorPhotosCount"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "localeOrigin"
},
v17 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "marketTrendsUrl"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numOfItemsToInflate"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "originalUrl"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v21 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v22 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v23 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "previewId"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v25 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regions"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionsList"
},
v27 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankGuestId"
},
v28 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankUserId"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v30 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipUser"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uriRef"
},
v32 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v33 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v34 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v35 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v36 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v37 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v38 = [
  {
    "kind": "Variable",
    "name": "disableForceFacet",
    "variableName": "disableForceFacet"
  },
  {
    "kind": "Variable",
    "name": "disableNonParameterizedUrlRedirects",
    "variableName": "disableNonParameterizedUrlRedirects"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "guestId",
    "variableName": "guestId"
  },
  {
    "kind": "Variable",
    "name": "includeSponsoredItems",
    "variableName": "includeSponsoredItems"
  },
  {
    "kind": "Variable",
    "name": "localeOrigin",
    "variableName": "localeOrigin"
  },
  {
    "kind": "Variable",
    "name": "numOfItemsToInflate",
    "variableName": "numOfItemsToInflate"
  },
  {
    "kind": "Variable",
    "name": "originalUrl",
    "variableName": "originalUrl"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  (v35/*: any*/),
  {
    "kind": "Variable",
    "name": "regions",
    "variableName": "regions"
  },
  {
    "kind": "Variable",
    "name": "regionsList",
    "variableName": "regionsList"
  },
  (v36/*: any*/),
  (v37/*: any*/),
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "personalizationId"
  }
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUriRef",
  "storageKey": null
},
v40 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v41 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v42 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v43 = [
  (v41/*: any*/),
  (v42/*: any*/)
],
v44 = [
  (v41/*: any*/),
  (v36/*: any*/),
  (v42/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contemporaryTrackingString",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "pdpMetaItems",
  "kind": "LinkedField",
  "name": "pdpMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topQuery",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attribution",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Creator",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v56/*: any*/),
    (v58/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStorefrontOnly",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v45/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v57/*: any*/),
                (v67/*: any*/),
                (v50/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v50/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse"
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v70/*: any*/),
    (v71/*: any*/)
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v75 = [
  (v72/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantityDisplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentageOff",
    "storageKey": null
  },
  (v73/*: any*/),
  (v74/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceVariability",
    "storageKey": null
  }
],
v76 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v77 = {
  "alias": "mobileTitle",
  "args": (v76/*: any*/),
  "kind": "ScalarField",
  "name": "title",
  "storageKey": "title(formatType:\"MOBILE\")"
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewParagraph",
  "kind": "LinkedField",
  "name": "paragraphs",
  "plural": true,
  "selections": [
    (v78/*: any*/),
    (v79/*: any*/),
    {
      "alias": "mobileText",
      "args": (v76/*: any*/),
      "kind": "ScalarField",
      "name": "text",
      "storageKey": "text(formatType:\"MOBILE\")"
    }
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v57/*: any*/),
    (v63/*: any*/)
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCategorySegments",
  "kind": "LinkedField",
  "name": "paragraphAttributeNames",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "origin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodPrefix",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    (v77/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/)
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v85 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v84/*: any*/)
],
v86 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "addLabel",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "fields",
      "value": [
        "height",
        "width",
        "depth",
        "diameter",
        "length"
      ]
    },
    {
      "kind": "Literal",
      "name": "separator",
      "value": " "
    }
  ],
  "concreteType": "ItemDisplayMeasurementType",
  "kind": "LinkedField",
  "name": "display",
  "plural": true,
  "selections": (v85/*: any*/),
  "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemSize",
  "kind": "LinkedField",
  "name": "size",
  "plural": false,
  "selections": [
    (v84/*: any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/)
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    (v89/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCalculated",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmounts",
      "kind": "LinkedField",
      "name": "convertedAmounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "USD",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            (v95/*: any*/),
            (v50/*: any*/)
          ],
          "storageKey": null
        },
        (v50/*: any*/)
      ],
      "storageKey": null
    },
    (v50/*: any*/)
  ],
  "storageKey": null
},
v97 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v101 = {
  "alias": "productPhotos",
  "args": (v97/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueChange",
  "storageKey": null
},
v105 = [
  (v72/*: any*/)
],
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "avgSalePrice",
  "plural": false,
  "selections": (v105/*: any*/),
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketTrendsPriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "low",
      "plural": false,
      "selections": (v105/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "high",
      "plural": false,
      "selections": (v105/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v111 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v112 = [
  (v57/*: any*/)
],
v113 = [
  {
    "kind": "Literal",
    "name": "address",
    "value": {
      "country": "us"
    }
  },
  {
    "kind": "Literal",
    "name": "regionBoundaryTypes",
    "value": [
      "METROPOLITAN",
      "DISTRICT",
      "DOMESTIC"
    ]
  },
  {
    "kind": "Literal",
    "name": "regionType",
    "value": "ITEM_LOCATION"
  }
],
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkReference",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "header",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
},
v121 = {
  "alias": "isRewarded",
  "args": [
    {
      "kind": "Literal",
      "name": "listNames",
      "value": [
        "SELLER_REWARDS_1",
        "SELLER_REWARDS_2"
      ]
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListsMember",
  "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hexCode",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedFilterName",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFurniture",
  "storageKey": null
},
v128 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v129 = {
  "alias": null,
  "args": [
    (v128/*: any*/),
    (v69/*: any*/),
    (v35/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v75/*: any*/),
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewListing",
  "storageKey": null
},
v131 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 28
  }
],
v132 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "IN"
        }
      ],
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurements",
      "plural": false,
      "selections": [
        (v102/*: any*/)
      ],
      "storageKey": "convertedMeasurements(unit:\"IN\")"
    },
    {
      "alias": "widthDimensions",
      "args": [
        (v132/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "width"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v85/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"width\"])"
    },
    {
      "alias": "heightDimensions",
      "args": [
        (v132/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v85/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"height\"])"
    }
  ],
  "storageKey": null
},
v134 = {
  "alias": "carouselPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 2
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v99/*: any*/),
    (v98/*: any*/),
    (v100/*: any*/),
    (v50/*: any*/),
    (v109/*: any*/)
  ],
  "storageKey": "photos(limit:2)"
},
v135 = {
  "alias": null,
  "args": (v97/*: any*/),
  "concreteType": "viewInRoomPhotos",
  "kind": "LinkedField",
  "name": "viewInRoomPhotos",
  "plural": true,
  "selections": [
    (v109/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosCenterPosition",
      "kind": "LinkedField",
      "name": "centerPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "top",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "left",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosComparatorWidth",
      "kind": "LinkedField",
      "name": "comparatorWidth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pixel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inches",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "viewInRoomPhotos(limit:1)"
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v137 = {
  "condition": "showSeller",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v136/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eyeBrowText",
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainImage",
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedLinkData",
  "kind": "LinkedField",
  "name": "localizedLinkDataList",
  "plural": true,
  "selections": [
    (v71/*: any*/),
    (v63/*: any*/)
  ],
  "storageKey": null
},
v141 = [
  (v108/*: any*/)
],
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photo",
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v144 = [
  (v128/*: any*/)
],
v145 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorText",
  "storageKey": null
},
v146 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "values",
  "storageKey": null
},
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartialItem",
  "storageKey": null
},
v152 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personalizationType",
  "storageKey": null
},
v153 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnHold",
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnavailable",
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccessible",
      "storageKey": null
    },
    (v50/*: any*/),
    (v45/*: any*/)
  ],
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            (v122/*: any*/),
            (v50/*: any*/),
            (v95/*: any*/)
          ],
          "storageKey": null
        },
        (v50/*: any*/)
      ],
      "storageKey": null
    },
    (v50/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/)
  ],
  "storageKey": null
},
v157 = {
  "alias": "displayPriceTracking",
  "args": [
    {
      "kind": "Literal",
      "name": "catchNonFatalErrors",
      "value": false
    },
    (v128/*: any*/),
    {
      "kind": "Variable",
      "name": "page",
      "variableName": "pageDisplayEnum"
    },
    (v35/*: any*/),
    (v37/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v72/*: any*/),
    (v74/*: any*/),
    (v73/*: any*/)
  ],
  "storageKey": null
},
v158 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "englishCountryName",
  "storageKey": null
},
v159 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    (v158/*: any*/),
    (v50/*: any*/),
    (v89/*: any*/)
  ],
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v58/*: any*/),
    (v50/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v47/*: any*/),
    (v77/*: any*/)
  ],
  "storageKey": null
},
v162 = {
  "alias": "productPhotos",
  "args": (v97/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v98/*: any*/),
    (v100/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v163 = {
  "condition": "fetchTileVideo",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasApprovedVideo",
      "storageKey": null
    }
  ]
},
v164 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v165 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "full",
  "storageKey": null
},
v166 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v167 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dek",
    "storageKey": null
  },
  (v119/*: any*/),
  (v63/*: any*/),
  (v139/*: any*/)
],
v168 = [
  (v146/*: any*/),
  (v145/*: any*/),
  (v50/*: any*/)
],
v169 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v170 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  (v50/*: any*/)
],
v171 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v172 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SbRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbRespComponents_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSbSharedPageTracking_viewer"
          },
          {
            "condition": "fetchSb",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v38/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v39/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbSharedRefetchContainer_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbRespComponents_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbSharedHead_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useSbSharedPageTracking_itemSearch"
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v40/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useSbSharedPageTracking_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SbRespComponents_user"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v43/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbSharedRefetchContainer_regionalInfo"
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasPersonalizedFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v44/*: any*/),
                "concreteType": "ShippingFilterType",
                "kind": "LinkedField",
                "name": "shippingFilters",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbSharedRefetchContainer_shippingFilters"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbRespComponents_shippingFilters"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v33/*: any*/),
      (v22/*: any*/),
      (v10/*: any*/),
      (v28/*: any*/),
      (v27/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v30/*: any*/),
      (v15/*: any*/),
      (v12/*: any*/),
      (v31/*: any*/),
      (v19/*: any*/),
      (v7/*: any*/),
      (v20/*: any*/),
      (v16/*: any*/),
      (v29/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v23/*: any*/),
      (v25/*: any*/),
      (v11/*: any*/),
      (v34/*: any*/),
      (v32/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v14/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v13/*: any*/),
      (v17/*: any*/),
      (v24/*: any*/),
      (v26/*: any*/),
      (v21/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Operation",
    "name": "SbRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "isRelatedCreatorsModuleEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "relatedCreatorsModule"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"relatedCreatorsModule\")"
          },
          {
            "alias": "isPopularSearchesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 18
              },
              {
                "kind": "Literal",
                "name": "recentlyViewedIds",
                "value": []
              },
              {
                "kind": "Literal",
                "name": "returnAmount",
                "value": 12
              },
              {
                "kind": "Literal",
                "name": "userIds",
                "value": []
              }
            ],
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "recommendedItems",
            "plural": true,
            "selections": [
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v68/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "isTrade",
                    "value": false
                  },
                  (v69/*: any*/)
                ],
                "concreteType": "ItemDisplayPriceType",
                "kind": "LinkedField",
                "name": "displayPrice",
                "plural": true,
                "selections": (v75/*: any*/),
                "storageKey": "displayPrice(isTrade:false,page:\"searchAndBrowse\")"
              },
              (v83/*: any*/),
              (v88/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v96/*: any*/),
              (v101/*: any*/),
              (v50/*: any*/)
            ],
            "storageKey": "recommendedItems(pageSize:18,recentlyViewedIds:[],returnAmount:12,userIds:[])"
          },
          {
            "alias": "video",
            "args": null,
            "concreteType": "VideoVimeo",
            "kind": "LinkedField",
            "name": "itemVideo",
            "plural": false,
            "selections": [
              {
                "alias": "videoThumb",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pad",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": "w295h166"
                  }
                ],
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": "thumbnail(pad:false,size:\"w295h166\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              (v102/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoVimeoFile",
                "kind": "LinkedField",
                "name": "fileByVideoSize",
                "plural": false,
                "selections": [
                  (v103/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "showCreatorDesignTiles",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "sbCreatorDesignTiles"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"sbCreatorDesignTiles\")"
          },
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              },
              {
                "kind": "Variable",
                "name": "uriRef",
                "variableName": "marketTrendsUrl"
              }
            ],
            "concreteType": "MarketTrendsConnection",
            "kind": "LinkedField",
            "name": "creatorMarketTrends",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketTrendsTopicDescription",
                "kind": "LinkedField",
                "name": "topicDescription",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPlural",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasArticle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketTrendsIconicDesign",
                "kind": "LinkedField",
                "name": "iconicDesigns",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketTrendsPriceStats",
                    "kind": "LinkedField",
                    "name": "priceStats",
                    "plural": false,
                    "selections": [
                      (v104/*: any*/),
                      (v106/*: any*/),
                      (v107/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconicDesign",
                    "kind": "LinkedField",
                    "name": "iconicDesign",
                    "plural": false,
                    "selections": [
                      (v57/*: any*/),
                      (v108/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "authorityImageUrl",
                        "storageKey": null
                      },
                      (v50/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketTrendsPriceStats",
                "kind": "LinkedField",
                "name": "priceStats",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itemsSold",
                    "storageKey": null
                  },
                  (v104/*: any*/),
                  (v106/*: any*/),
                  (v107/*: any*/),
                  (v109/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketTrendsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketTrendsTopSales",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rank",
                        "storageKey": null
                      },
                      (v110/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "itemTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v111/*: any*/),
                        "kind": "ScalarField",
                        "name": "itemThumbnail",
                        "storageKey": "itemThumbnail(size:\"thumb\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pdpUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "salePrice",
                        "plural": false,
                        "selections": (v105/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateSold",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v109/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v50/*: any*/),
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "regionsInfo",
                "args": (v43/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": (v112/*: any*/),
                    "storageKey": null
                  },
                  (v50/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v43/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": [
                      (v57/*: any*/),
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v50/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isTrade",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v113/*: any*/),
                "concreteType": "Region",
                "kind": "LinkedField",
                "name": "regions",
                "plural": true,
                "selections": [
                  (v95/*: any*/),
                  (v108/*: any*/),
                  (v50/*: any*/)
                ],
                "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")"
              },
              {
                "condition": "isClient",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v44/*: any*/),
                    "concreteType": "ShippingFilterType",
                    "kind": "LinkedField",
                    "name": "shippingFilters",
                    "plural": true,
                    "selections": [
                      (v114/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v115/*: any*/),
                          (v108/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isTrade",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v113/*: any*/),
                    "concreteType": "Region",
                    "kind": "LinkedField",
                    "name": "regions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "kind": "LinkedField",
                        "name": "regionBoundary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RegionBoundaryType",
                            "kind": "LinkedField",
                            "name": "type",
                            "plural": false,
                            "selections": [
                              (v114/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "locations",
                "args": [
                  (v41/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "facetLimit",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "facetName",
                    "value": "location"
                  },
                  (v36/*: any*/),
                  (v42/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "kind": "LinkedField",
                "name": "itemFacetSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v116/*: any*/),
                          (v57/*: any*/),
                          (v108/*: any*/),
                          (v115/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "rerankGuestId"
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "rerankUserId"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEligibleForRerank",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchSb",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v38/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v39/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vanityUriRef",
                    "storageKey": null
                  },
                  (v117/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isL1LandingPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "kind": "LinkedField",
                    "name": "bottomModule",
                    "plural": true,
                    "selections": [
                      (v47/*: any*/),
                      (v118/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subHeader",
                        "storageKey": null
                      },
                      (v119/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attributeDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prev",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableIndexing",
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "topQueries",
                        "storageKey": null
                      },
                      (v118/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canonical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "next",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanguageAnnotations",
                        "kind": "LinkedField",
                        "name": "languageAnnotations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hrefLang",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "microdata",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v120/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "kind": "LinkedField",
                    "name": "searchCorrections",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forceSearchUri",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalSearchTerm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "semanticSearchTerm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "classificationSearchTerm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchCorrectionSuggestionsValues",
                        "kind": "LinkedField",
                        "name": "suggestions",
                        "plural": true,
                        "selections": [
                          (v114/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uri",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v120/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      (v121/*: any*/),
                      (v50/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v114/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          (v57/*: any*/),
                          (v122/*: any*/),
                          (v115/*: any*/),
                          (v116/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v123/*: any*/),
                              (v124/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v125/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canBeDismissed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clearAllLinkReference",
                        "storageKey": null
                      },
                      (v126/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v79/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  (v52/*: any*/),
                                  (v127/*: any*/),
                                  (v47/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v63/*: any*/),
                                  (v91/*: any*/),
                                  (v96/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v68/*: any*/),
                                  (v129/*: any*/),
                                  (v83/*: any*/),
                                  (v88/*: any*/),
                                  (v90/*: any*/),
                                  (v101/*: any*/),
                                  (v130/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v111/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                                  },
                                  (v46/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:20)"
                  },
                  {
                    "alias": "soldItems",
                    "args": (v131/*: any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      (v117/*: any*/)
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": "soldItemResults",
                    "args": (v131/*: any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  (v127/*: any*/),
                                  (v47/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v63/*: any*/),
                                  (v91/*: any*/),
                                  (v96/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v128/*: any*/),
                                      (v69/*: any*/)
                                    ],
                                    "concreteType": "ItemDisplayPriceType",
                                    "kind": "LinkedField",
                                    "name": "displayPrice",
                                    "plural": true,
                                    "selections": (v75/*: any*/),
                                    "storageKey": null
                                  },
                                  (v83/*: any*/),
                                  (v133/*: any*/),
                                  (v90/*: any*/),
                                  (v101/*: any*/),
                                  (v52/*: any*/),
                                  (v130/*: any*/),
                                  (v134/*: any*/),
                                  (v135/*: any*/),
                                  (v46/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  (v50/*: any*/),
                                  (v137/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "contentModuleId",
                        "variableName": "contentModuleId"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "browseContentModule",
                    "plural": false,
                    "selections": [
                      (v109/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrowseContentModuleBannerType",
                            "kind": "LinkedField",
                            "name": "banners",
                            "plural": true,
                            "selections": [
                              (v109/*: any*/),
                              (v47/*: any*/),
                              (v118/*: any*/),
                              (v138/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaCopy",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaStyle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textAlignment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textColor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backgroundColor",
                                "storageKey": null
                              },
                              (v139/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "format",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textPosition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bannerImageWidth",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "termsLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrowseContentModuleTile",
                            "kind": "LinkedField",
                            "name": "tiles",
                            "plural": true,
                            "selections": [
                              (v67/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "content",
                                "storageKey": null
                              },
                              (v63/*: any*/),
                              (v140/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ContentModuleBannerTiles",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleType",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v121/*: any*/),
                              (v136/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": (v141/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StorefrontProfile",
                                "kind": "LinkedField",
                                "name": "liveStorefrontProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v118/*: any*/),
                          (v47/*: any*/),
                          (v142/*: any*/)
                        ],
                        "type": "ContentModuleRegular",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v142/*: any*/),
                          (v47/*: any*/),
                          (v143/*: any*/),
                          (v118/*: any*/),
                          (v103/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkText",
                            "storageKey": null
                          }
                        ],
                        "type": "ContentModuleBanner",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v118/*: any*/),
                          (v47/*: any*/),
                          (v139/*: any*/)
                        ],
                        "type": "ContentModuleIconicDesign",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerImage",
                            "storageKey": null
                          },
                          (v138/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "landingBackgroundTintColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "landingTilesBackgroundColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "landingTextColor",
                            "storageKey": null
                          },
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrowseContentModuleLandingTile",
                            "kind": "LinkedField",
                            "name": "landingTiles",
                            "plural": true,
                            "selections": [
                              (v47/*: any*/),
                              (v67/*: any*/),
                              (v63/*: any*/),
                              (v140/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ContentModuleLanding",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v144/*: any*/),
                    "concreteType": "SearchBrowsePriceTile",
                    "kind": "LinkedField",
                    "name": "priceTiles",
                    "plural": true,
                    "selections": (v112/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RelatedSearch",
                    "kind": "LinkedField",
                    "name": "relatedSearches",
                    "plural": true,
                    "selections": [
                      (v145/*: any*/),
                      (v146/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "kind": "LinkedField",
                    "name": "categoryTiles",
                    "plural": true,
                    "selections": [
                      (v57/*: any*/),
                      (v110/*: any*/),
                      (v146/*: any*/),
                      (v147/*: any*/),
                      (v109/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canFollowSearch",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topCategoryL1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayMaxNumberOfPages",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      (v114/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v115/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkable",
                            "storageKey": null
                          },
                          (v57/*: any*/),
                          (v108/*: any*/),
                          (v71/*: any*/),
                          (v116/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "stats",
                            "kind": "LinkedField",
                            "name": "stats",
                            "plural": true,
                            "selections": [
                              (v78/*: any*/),
                              (v148/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v125/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v123/*: any*/),
                              (v124/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "min",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v122/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v126/*: any*/),
                      (v149/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalFilterName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAttributePage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SortType",
                    "kind": "LinkedField",
                    "name": "sort",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          (v115/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "kind": "LinkedField",
                        "name": "currentOption",
                        "plural": false,
                        "selections": (v141/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchRequestId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchSponsored",
                    "kind": "LinkedField",
                    "name": "sponsored",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxAvailable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchSponsoredMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": true,
                        "selections": [
                          (v110/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "impressionTrackerLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clickTrackerLink",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v150/*: any*/),
                          (v151/*: any*/),
                          (v152/*: any*/),
                          (v52/*: any*/),
                          (v153/*: any*/),
                          (v154/*: any*/),
                          (v155/*: any*/),
                          (v156/*: any*/),
                          (v47/*: any*/),
                          (v157/*: any*/),
                          (v159/*: any*/),
                          (v49/*: any*/),
                          (v48/*: any*/),
                          (v46/*: any*/),
                          (v130/*: any*/),
                          (v91/*: any*/),
                          (v54/*: any*/),
                          (v133/*: any*/),
                          (v60/*: any*/),
                          (v55/*: any*/),
                          (v160/*: any*/),
                          (v63/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v68/*: any*/),
                          (v129/*: any*/),
                          (v161/*: any*/),
                          (v134/*: any*/),
                          (v53/*: any*/),
                          (v64/*: any*/),
                          (v135/*: any*/),
                          (v162/*: any*/),
                          (v50/*: any*/),
                          (v137/*: any*/),
                          (v163/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v150/*: any*/),
                              (v151/*: any*/),
                              (v152/*: any*/),
                              (v52/*: any*/),
                              (v153/*: any*/),
                              (v154/*: any*/),
                              (v155/*: any*/),
                              (v156/*: any*/),
                              (v47/*: any*/),
                              (v157/*: any*/),
                              (v159/*: any*/),
                              (v49/*: any*/),
                              (v48/*: any*/),
                              (v46/*: any*/),
                              (v130/*: any*/),
                              (v91/*: any*/),
                              (v54/*: any*/),
                              (v133/*: any*/),
                              (v60/*: any*/),
                              (v55/*: any*/),
                              (v160/*: any*/),
                              (v63/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v68/*: any*/),
                              (v129/*: any*/),
                              (v161/*: any*/),
                              (v134/*: any*/),
                              (v53/*: any*/),
                              (v64/*: any*/),
                              (v135/*: any*/),
                              (v162/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": (v97/*: any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v100/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              (v137/*: any*/),
                              (v163/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "relatedItems",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 12
                      }
                    ],
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  (v54/*: any*/),
                                  (v133/*: any*/),
                                  (v60/*: any*/),
                                  (v47/*: any*/),
                                  (v55/*: any*/),
                                  (v160/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v68/*: any*/),
                                  (v129/*: any*/),
                                  (v91/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ShipmentQuote",
                                    "kind": "LinkedField",
                                    "name": "shipmentQuotes",
                                    "plural": true,
                                    "selections": [
                                      (v92/*: any*/),
                                      (v93/*: any*/),
                                      (v94/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ShipmentServiceMethod",
                                        "kind": "LinkedField",
                                        "name": "serviceMethod",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Region",
                                            "kind": "LinkedField",
                                            "name": "region",
                                            "plural": false,
                                            "selections": [
                                              (v95/*: any*/),
                                              (v50/*: any*/),
                                              (v122/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v50/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v50/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v161/*: any*/),
                                  (v134/*: any*/),
                                  (v53/*: any*/),
                                  (v64/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "kind": "LinkedField",
                                    "name": "address",
                                    "plural": false,
                                    "selections": [
                                      (v89/*: any*/),
                                      (v50/*: any*/),
                                      (v158/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v135/*: any*/),
                                  (v130/*: any*/),
                                  (v52/*: any*/),
                                  (v162/*: any*/),
                                  (v153/*: any*/),
                                  (v150/*: any*/),
                                  (v154/*: any*/),
                                  (v155/*: any*/),
                                  (v157/*: any*/),
                                  (v49/*: any*/),
                                  (v48/*: any*/),
                                  (v46/*: any*/),
                                  (v152/*: any*/),
                                  (v50/*: any*/),
                                  (v137/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:12)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  (v47/*: any*/),
                                  (v51/*: any*/),
                                  (v157/*: any*/),
                                  (v159/*: any*/),
                                  (v49/*: any*/),
                                  (v48/*: any*/),
                                  (v46/*: any*/),
                                  (v130/*: any*/),
                                  (v152/*: any*/),
                                  (v91/*: any*/),
                                  (v96/*: any*/),
                                  (v54/*: any*/),
                                  (v133/*: any*/),
                                  (v60/*: any*/),
                                  (v55/*: any*/),
                                  (v160/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v68/*: any*/),
                                  (v129/*: any*/),
                                  (v161/*: any*/),
                                  (v134/*: any*/),
                                  (v53/*: any*/),
                                  (v64/*: any*/),
                                  (v135/*: any*/),
                                  (v52/*: any*/),
                                  (v162/*: any*/),
                                  (v50/*: any*/),
                                  (v137/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clearAppliedFiltersLinkReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "interiorPhotosCount"
                      },
                      {
                        "kind": "Literal",
                        "name": "template",
                        "value": "tradeProjectPhoto.search"
                      }
                    ],
                    "concreteType": "SearchBrowseInteriorPhotosModule",
                    "kind": "LinkedField",
                    "name": "interiorPhotos",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InteriorPhotosModulePhotoSearchParam",
                        "kind": "LinkedField",
                        "name": "photoSearchParam",
                        "plural": false,
                        "selections": [
                          (v114/*: any*/),
                          (v148/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "photosBrowseLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InteriorPhotosModuleSearchBrowseBackLink",
                        "kind": "LinkedField",
                        "name": "searchBrowseBackLink",
                        "plural": false,
                        "selections": [
                          (v57/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkData",
                        "kind": "LinkedField",
                        "name": "relatedPhotoSearchLinks",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          (v79/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhotosSearchBrowsePhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v50/*: any*/),
                          (v61/*: any*/),
                          (v114/*: any*/),
                          (v146/*: any*/),
                          (v45/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhotoLike",
                            "kind": "LinkedField",
                            "name": "photoLike",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalPhotoLikes",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v117/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "editorial",
                    "args": (v164/*: any*/),
                    "concreteType": "WordpressArticlesType",
                    "kind": "LinkedField",
                    "name": "editorialArticles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleType",
                        "kind": "LinkedField",
                        "name": "articles",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publishedDate",
                            "storageKey": null
                          },
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticleImageType",
                            "kind": "LinkedField",
                            "name": "imageUrl",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "thumb",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medium",
                                "storageKey": null
                              },
                              (v165/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v143/*: any*/),
                          (v103/*: any*/),
                          (v166/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v117/*: any*/)
                    ],
                    "storageKey": "editorialArticles(first:8)"
                  },
                  {
                    "alias": null,
                    "args": (v164/*: any*/),
                    "concreteType": "WordpressArticlesType",
                    "kind": "LinkedField",
                    "name": "editorialArticles",
                    "plural": false,
                    "selections": [
                      (v117/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleType",
                        "kind": "LinkedField",
                        "name": "articles",
                        "plural": true,
                        "selections": [
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticleImageType",
                            "kind": "LinkedField",
                            "name": "imageUrl",
                            "plural": false,
                            "selections": [
                              (v165/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v143/*: any*/),
                          (v103/*: any*/),
                          (v166/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "editorialArticles(first:8)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDeal",
                    "kind": "LinkedField",
                    "name": "featuredDeal",
                    "plural": false,
                    "selections": [
                      (v67/*: any*/),
                      (v91/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "kind": "LinkedField",
                        "name": "convertedAmountList",
                        "plural": true,
                        "selections": [
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v63/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "previewId",
                        "variableName": "previewId"
                      }
                    ],
                    "concreteType": "L1Module",
                    "kind": "LinkedField",
                    "name": "l1Module",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "L1ModuleItemTile",
                        "kind": "LinkedField",
                        "name": "banners",
                        "plural": true,
                        "selections": (v167/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "L1ModuleItemTile",
                        "kind": "LinkedField",
                        "name": "firstTile",
                        "plural": false,
                        "selections": [
                          (v139/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "L1ModuleItemTile",
                        "kind": "LinkedField",
                        "name": "secondTile",
                        "plural": false,
                        "selections": (v167/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": [
                      (v79/*: any*/),
                      (v61/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "relatedPages",
                    "plural": true,
                    "selections": (v168/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "relatedCreatorsConnection",
                    "kind": "LinkedField",
                    "name": "relatedCreators",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "relatedCreatorsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RelatedCreatorType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              {
                                "alias": "shopAllTitle",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": "creatorName",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageObjectName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v109/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v47/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v97/*: any*/),
                                        "concreteType": "ItemPhoto",
                                        "kind": "LinkedField",
                                        "name": "photos",
                                        "plural": true,
                                        "selections": [
                                          (v99/*: any*/),
                                          (v50/*: any*/)
                                        ],
                                        "storageKey": "photos(limit:1)"
                                      }
                                    ],
                                    "type": "Item",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v50/*: any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": (v168/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "faqHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuestionType",
                    "kind": "LinkedField",
                    "name": "questionsAnswers",
                    "plural": true,
                    "selections": [
                      (v50/*: any*/),
                      (v146/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answerCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerType",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedCreatedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  (v169/*: any*/),
                                  (v108/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scrollLogo",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appliedPersonalizationList",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "seoAbTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackedAbTests",
                    "storageKey": null
                  },
                  (v50/*: any*/),
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v144/*: any*/),
                        "concreteType": "SearchBrowsePriceTile",
                        "kind": "LinkedField",
                        "name": "priceTiles",
                        "plural": true,
                        "selections": [
                          (v71/*: any*/),
                          (v147/*: any*/),
                          (v146/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFacets",
                        "kind": "LinkedField",
                        "name": "facets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacetValueType",
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": true,
                            "selections": [
                              (v114/*: any*/),
                              (v169/*: any*/),
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v40/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVerifiedTrade",
                        "storageKey": null
                      },
                      (v109/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": [
                                      (v122/*: any*/),
                                      (v50/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowSellerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowFolder",
                        "storageKey": null
                      },
                      {
                        "alias": "hasMerchandizingPermission",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "BUYER_FE_MERCH_TOOL"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                      },
                      {
                        "alias": "canShowStorefrontOnlyBadge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "VIEW_STOREFRONT_ONLY_BADGE"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                      },
                      {
                        "alias": "canShowInternalSellerName",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "VIEW_SELLER_NAME"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPreferences",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "measurementUnit",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressBook",
                        "kind": "LinkedField",
                        "name": "addressBook",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "personalAddress",
                            "plural": false,
                            "selections": (v170/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "proAddress",
                            "plural": false,
                            "selections": (v170/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "addressList",
                            "plural": true,
                            "selections": (v170/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "showStrategicPartnerFilter",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "STRATEGIC_PARTNER_FILTERING"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                      },
                      {
                        "alias": "hasBasicInternalPermission",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "BASIC_INTERNAL"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"BASIC_INTERNAL\")"
                      },
                      (v50/*: any*/),
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "daysToExpiration",
                                "value": 7
                              },
                              {
                                "kind": "Literal",
                                "name": "promoCodes",
                                "value": [
                                  "TRADEWELCOME",
                                  "TRADE1STWELCOME"
                                ]
                              }
                            ],
                            "concreteType": "Promotion",
                            "kind": "LinkedField",
                            "name": "expiringPromotion",
                            "plural": false,
                            "selections": [
                              (v171/*: any*/),
                              (v122/*: any*/),
                              (v50/*: any*/)
                            ],
                            "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "tradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v40/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Promotion",
                                    "kind": "LinkedField",
                                    "name": "promotion",
                                    "plural": false,
                                    "selections": [
                                      (v122/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "buyerExpirationDate",
                                        "storageKey": null
                                      },
                                      (v50/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "expiringPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "expiringPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expiringSegmentCode",
                                    "storageKey": null
                                  },
                                  (v171/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v172/*: any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v45/*: any*/),
                                      (v57/*: any*/),
                                      (v50/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v109/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v172/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "hasPersonalizedFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v44/*: any*/),
                "concreteType": "ShippingFilterType",
                "kind": "LinkedField",
                "name": "shippingFilters",
                "plural": true,
                "selections": [
                  (v149/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/543.0.0-2026-01-22T17:55:48.216Z/SbRespLayoutRefetchQuery",
    "metadata": {},
    "name": "SbRespLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7b9ef57450c1beb70dd2cfd27f9fa797";

export default node;
